import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Row, Col, Spin, Empty, Tabs } from 'antd';
import { getProducts } from '../api/product';
import { formatPrice } from '../utils/format';
import { localizeProducts } from '../utils/localizeProduct';
import { useI18n } from '../i18n/I18nContext';
import './Home.css';

const { Meta } = Card;

const CATEGORY_KEYS = ['all', '现代简约', '原木风', '北欧风', '法式', '美式', '中古风'];

function Home() {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState('all');
  const navigate = useNavigate();
  const { t, tc, locale } = useI18n();

  useEffect(() => {
    fetchProducts();
  }, []);

  useEffect(() => {
    filterProducts();
  }, [activeCategory, products]);

  const fetchProducts = async () => {
    try {
      setLoading(true);
      const response = await getProducts();
      if (response.success) {
        setProducts(response.data);
      }
    } catch (error) {
      console.error('获取商品列表失败:', error);
    } finally {
      setLoading(false);
    }
  };

  const filterProducts = () => {
    if (activeCategory === 'all') {
      setFilteredProducts(products);
    } else {
      setFilteredProducts(products.filter((p) => p.category === activeCategory));
    }
  };

  const handleCategoryChange = (key) => {
    setActiveCategory(key);
  };

  const handleProductClick = (productId) => {
    navigate(`/product/${productId}`);
  };

  if (loading) {
    return (
      <div className="loading-container">
        <Spin size="large" tip={t('home.loading')} />
      </div>
    );
  }

  const noImageUrl = `https://via.placeholder.com/400x250?text=${encodeURIComponent(t('home.noImage'))}`;
  const displayList = localizeProducts(filteredProducts, locale);

  return (
    <div className="home-container">
      <div className="products-section">
        <h2 className="section-title">{t('home.sectionTitle')}</h2>

        <Tabs
          activeKey={activeCategory}
          onChange={handleCategoryChange}
          items={CATEGORY_KEYS.map((key) => ({
            key,
            label: key === 'all' ? t('home.all') : tc(key),
          }))}
          className="category-tabs"
        />

        {filteredProducts.length === 0 ? (
          <Empty description={t('home.empty')} />
        ) : (
          <Row gutter={[16, 16]}>
            {displayList.map((product) => (
              <Col xs={12} sm={12} md={8} lg={6} xl={6} key={product.id}>
                <Card
                  hoverable
                  cover={
                    <div className="product-image-wrapper">
                      <img
                        alt={product.name}
                        src={product.image}
                        className="product-image"
                        onError={(e) => {
                          e.target.src = noImageUrl;
                        }}
                      />
                      <div className="product-category-tag">{tc(product.category)}</div>
                    </div>
                  }
                  onClick={() => handleProductClick(product.id)}
                  className="product-card"
                >
                  <Meta
                    title={<div className="product-name">{product.name}</div>}
                    description={
                      <div className="product-info">
                        <p className="product-desc">{product.description}</p>
                        <p className="product-price">{formatPrice(product.price, locale)}</p>
                      </div>
                    }
                  />
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </div>
    </div>
  );
}

export default Home;
